import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './promotion-card.magic.css.js';
import script from './promotion-card.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotion-card",attrs:{"part":"promotion-card","data-v-test-id":"promotion-card-container"}},[_c('div',{staticClass:"header",attrs:{"part":"header"}},[(_vm.src)?_c('picture',{staticClass:"picture",attrs:{"part":"picture"}},[_c('source',{attrs:{"type":"image/avif","srcset":_vm.avifSrcset}}),_vm._v(" "),_c('source',{attrs:{"type":"image/webp","srcset":_vm.webpSrcset}}),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"part":"image","loading":"lazy","src":_vm.src,"alt":_vm.promotion.title}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"content",attrs:{"part":"content"}},[(_vm.tag)?_c('magic-ui-tag',{staticClass:"tag",attrs:{"part":"tag"},domProps:{"innerHTML":_vm._s(_vm.tag)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wrapper",attrs:{"part":"wrapper"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h5","part":"title","content":_vm.promotion.title}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.promotion.subtitle}})],1),_vm._v(" "),_c('div',{staticClass:"action",attrs:{"part":"action"}},[(_vm.showOptIn)?_vm._l((_vm.optIns),function(button,i){return _c('magic-ui-button',{key:i,staticClass:"button",attrs:{"wide":"","small":"","button-tag":"a","variant":"secondary","part":"button","data-v-test-id":"promotion-card-button","href":button.link,"loading":_vm.isOptingIn,"disabled":_vm.hasOptedIn},domProps:{"innerHTML":_vm._s(_vm.hasOptedIn ? _vm.$t('promotion-card.opted-in') : button.text)},on:{"click":function($event){return _vm.onCtaClick(button, $event)}}})}):_vm._e(),_vm._v(" "),_c('magic-ui-link',{staticClass:"button",attrs:{"button":"","wide":"","small":"","variant":"secondary","part":"button","data-v-test-id":"promotion-card-link","hollow":_vm.showOptIn},domProps:{"to":{
                    route: _vm.RoutablePage.PROMOTION,
                    params: {
                        slug: _vm.promotion.slug,
                    }
                },"innerHTML":_vm._s(_vm.$t('promotion-card.button'))}})],2),_vm._v(" "),_vm._l((_vm.linkCtas),function(link,i){return _c('magic-ui-link',{key:i,staticClass:"link",attrs:{"part":"link","data-v-test-id":"promotion-card-bottom-link","href":link.link},domProps:{"innerHTML":_vm._s(link.text)}})})],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-70c26b49_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-70c26b49";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
